import { ChatAttachment } from '../../../../types'
import { Attachments } from '../../attachments'
import { memo } from 'react'

export const MessageAttachments = memo(
  ({
    messageId,
    conversationId,
    attachments,
  }: {
    messageId: string
    conversationId?: string
    attachments: ChatAttachment[]
  }) => {
    return (
      <div
        className={
          'selection:bg-light-15 selection:text-light-80 flex min-h-[26px] flex-wrap items-center justify-end gap-1'
        }
      >
        <Attachments
          messageId={messageId}
          conversationId={conversationId}
          attachments={attachments}
          canRemove={false}
        />
      </div>
    )
  },
)
MessageAttachments.displayName = 'MessageAttachments'
